import { Icon24Minus } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const MinusIconLocal: SvgComponent = ({ title, strokeWidth = 1.13, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M3.75 12H20.25"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MinusIcon = fplIcon(MinusIconLocal, Icon24Minus);
